<template>
  <div class="SeloRegistro">
    <div class="SeloRegistro_header">
      <div class="row">
        <div class="col">
          <label class="label SeloRegistro_title pl-2">
            Selos neste registro
          </label>
        </div>
      </div>
    </div>

    <div v-if="selosNoRegistro.length > 0">
      <ListagemSelos :prop-selos="selosNoRegistro"
                     :prop-registro-id="propRegistroId"
                     :prop-radio-button="true"
                     @indexSeloSelecionado="indexSeloSelecionado" />

      <div class="row mt-3 mb-4">
        <div class="col-10 paginate d-inline-flex justify-content-center align-items-center">
          <p class="paginate_text small d-inline-block mt-0 paginate_padding_label_pagina">
            Página
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': (Number(page) === 1) }"
                  :disabled="(Number(page) === 1)"
                  type="button"
                  title="Página anterior"
                  @click="paginaAnterior()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrow_left.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            <select v-model="page"
                    class="form-control form-control-sm"
                    @change="selecionaPagina(page)">
              <option v-for="(value, index) in lastPage"
                      :key="`option_paginate_selos_registro_${ index }_${ _uid }`">
                {{ value }}
              </option>
            </select>
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': Number(page) === lastPage }"
                  :disabled="(Number(page) === lastPage)"
                  type="button"
                  title="Próxima página"
                  @click="proximaPagina()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrow_right.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            {{ `de ${lastPage}` }}
          </p>
        </div>

        <div class="col-2 d-inline-flex justify-content-end">
          <button class="btn btn-sm btn-primary"
                  :disabled="typeof indexSeloSelected === 'object' ? true : false"
                  @click="vincularSelo()"
                  @keyup.enter="vincularSelo()">
            Vincular Selos
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <label class="pt-3 pl-3">
        Nenhum selo encontrado neste registro. Aguardando a criação de uma OS.
      </label>
    </div>
  </div>
</template>

<script>
  /* assets */
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'

  /* services */
  import SelosService from '@/services/Registros/SelosService'

  /* components */
  import ListagemSelos from '@/components/SofiaRei/Resumo/Selo/ListagemSelos'

  export default {
    name: 'SelosRegistro',
    components: {
      ListagemSelos
    },
    props: {
      propRegistroId: { type: Number, default: () => null }
    },
    data () {
      return {
        // icons
        arrow_left,
        arrow_right,

        // paginate
        page: 1,
        lastPage: 1,
        perPage: 4,

        // controla os selos
        selosNoRegistro: [],
        indexSeloSelected: null
      }
    },
    watch: {
      propRegistroId: function (newValue) {
        if (newValue) this.init()
      }
    },
    beforeMount () {
      this.init()
    },
    methods: {
      async init () {
        await this.getSelos()

        this.$emit('listaSelos', this.selosNoRegistro)
      },

      async getSelos () {
        if (!this.propRegistroId) {
          this.selosNoRegistro = []
          return
        }

        loader({ text: 'Buscando selos nesse registro...', active: true })

        const params = {
          page: this.page,
          perPage: this.perPage,
          registro_id: this.propRegistroId
        }

        try {
          const selosNoRegistro = await SelosService.getSelo(params)

          // Atualizamos os dados das páginas
          this.selosNoRegistro = [...selosNoRegistro.data]

          for (const seloNoRegistro of this.selosNoRegistro) {
            seloNoRegistro.disableRadioButton = !!seloNoRegistro.vinculador 
          }

          this.lastPage = selosNoRegistro.lastPage
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar os selos desse registro'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)
        } finally {
          loader({ text: '', active: false })
        }
      },

      indexSeloSelecionado (index = null) {
        this.indexSeloSelected = index
      },

      paginaAnterior () {
        this.page = Number(this.page) - 1

        return this.getSelos()
      },

      selecionaPagina (page = 1) {
        this.page = Number(page)

        return this.getSelos()
      },

      proximaPagina () {
        this.page = Number(this.page) + 1

        return this.getSelos()
      },

      vincularSelo () {
        this.$emit('changeSeloVinculador', this.selosNoRegistro[this.indexSeloSelected])
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .SeloRegistro {
    &_header {
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(8);
      background-color: #f0ecec;
      line-height: 35px;
    }

    &_title {
      font-size: pxToRem(17) !important;
      font-weight: 500;
    }
  }

  .Listagem {
    width: 100%;
    font-size: 17.5px;
  
    &_titulo {
      background-color: $water-green-color;
      line-height: 37px;
    }

    &_radio_button {
      width: 5%;
    }

    &_selo {
      width: 35%;
    }

    &_os {
      width: 15%;
    }

    &_alerta {
      width: 45%;
    }

    &_linha_clara {
      line-height: 35px;
      border-bottom: 1.5px solid $color-gray;
    }

    &_linha_escura {
      line-height: 35px;
      background-color: #f0ecec;
      border-bottom: 1.5px solid $color-gray;
    }

    &_padding_os {
      padding-bottom: 30px;
    }

    &_padding_selo {
      padding-left: 41px;
      margin-top: -10px;
    }

    &_alerta {
      color: #8b0000;
      width: 100%;
      padding-bottom: 30px;
    }

    &_margin_reticencias {
      margin-left: -3px;
    }
  }

  .paginate {
    &_padding_label_pagina {
      padding-left: 20.5%
    }

    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }
</style>
